import React, { useEffect, useState } from 'react';
import "./art.css";
import MyButton from "./MyButton";
import AOS from "aos";

function ContactForm(props) {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        AOS.init({ duration: 1000, easing: "ease-in-out" });
    }, []);

    const imageSrc = props.imageRoute;
    const imgName = props.imageName;
    const desc = props.desc;
    const med = props.med;
    
    return (
        <div>
            <div className={`artwork ${props.imgShape}`} data-aos="fade-up">
                <img
                    src={imageSrc}
                    alt={imgName}
                    onClick={() => setIsOpen(true)}
                />
            </div>

            {isOpen && (
                <div
                    className="popUp"
                    onClick={() => setIsOpen(false)}   // 👈 click outside closes
                >
                    <div
                        className="popUpContent"
                        onClick={(e) => e.stopPropagation()} // 👈 prevent close
                    >
                        <img src={imageSrc} alt={imgName} />
                        <h3>{imgName}</h3>
                        <p className='artDesc'>Medium: {med}</p>
                        {/* <p className='artDesc'>{desc}</p> */}
                        <MyButton
                            btnText="Close"
                            onClick={() => setIsOpen(false)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default ContactForm;
